import { EventEmitter, Output, Directive, Input, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[CharLimit]',
  host: {
    '(ngModelChange)': 'onInputChange($event)',
  }
})
export class TACharLimit {

  constructor(public model: NgControl, private el: ElementRef) { }

  @Output() rawChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() MaxChar: number;
  onInputChange(value) {
    if (value !== null) {
      let count = value.replace(/\s/g, '').length;
      if (count > this.MaxChar) {
        value = this.setLimitTextArea(value, this.MaxChar);
        count = this.MaxChar;
      }
      const mathint = `Characters count (not includes spaces) ${count} / ${this.MaxChar}`
      this.el.nativeElement.parentElement.parentElement.parentElement.querySelector('mat-hint').innerHTML = mathint;
      // this.model.valueAccessor.writeValue(y);
      this.model.control.setValue(value, { emitViewToModelChange: false })
      this.rawChange.emit(value);
    }

  }
  //trim extra characters 
  setLimitTextArea(value, maxLength: number): any {
    if (value != null) {
      let trimValue = value.replace(/\s/g, '');
      while (trimValue.length > maxLength) {
        value = value.substring(0, value.length - 1);
        trimValue = value.replace(/\s/g, '');
      }
    }
    return value;
  }
}


  //   onInputChange(event, backspace) {
  //     // remove all mask characters (keep only numeric)
  //     let newVal = (event || '').replace(/\D/g, '');
  //     let rawValue = newVal;
  //     // special handling of backspace necessary otherwise
  //     // deleting of non-numeric characters is not recognized
  //     // this laves room for improvment for example if you delete in the
  //     // middle of the string
  //     if (backspace) {
  //       newVal = newVal.substring(0, newVal.length - 1);
  //     }
  //     // don't show braces for empty value
  //     if (newVal.length === 0) {
  //       newVal = '';
  //     } else if (newVal.length <= 2) {
  //       newVal = newVal.replace(/(\d{0,2})/, '$1');
  //     } 
  //     else {
  //       newVal = newVal.replace(/^(\d{0,2})(\d{0,7})(.*)/, '$1-$2');
  //     } 
  //     // else if (newVal.length <= 10) {
  //     //   newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1-$2-$3');
  //     // }
  //     // set the new value
  //     this.model.valueAccessor.writeValue(newVal);
  //     this.rawChange.emit(rawValue);
  //   }
  // }


  // onInputChange(value) {
  //   var x = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,7})/);
  //   var y = !x[2] ? x[1] : x[1] + '-' + x[2];

  //   this.model.valueAccessor.writeValue(y);
  //   this.rawChange.emit(value);
  // }
